import PasswordSettingsSection from './PasswordSettingsSection'

export default PasswordSettingsSection
